import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getMediaState = (state: GlobalState) => state[KEY];

const selectAction = createSelector(getMediaState, (state) => state.action);

const selectConfiguration = createSelector(getMediaState, (state) => state.configuration);

const selectAttractMediaType = createSelector(getMediaState, (state) => state.attract.mediaType);

const selectEnvironment = createSelector(getMediaState, (state) => state.environment);

const selectEvent = createSelector(getMediaState, (state) => state.event.selected);

const selectVenue = createSelector(getMediaState, (state) => state.venue.selected);

const selectGenre = createSelector(getMediaState, (state) => state.genre.selected);

const selectEventImages = createSelector(getMediaState, (state) => state.event.media);

const selectVenueImages = createSelector(getMediaState, (state) => state.venue.media);

const selectGenreImages = createSelector(getMediaState, (state) => state.genre.media);

const selectAttractImages = createSelector(getMediaState, (state) => state.attract.media);

const selectOtherImages = createSelector(getMediaState, (state) => state.otherImages);

export const selectors = {
  selectAction,
  selectConfiguration,
  selectAttractMediaType,
  selectEnvironment,
  selectEvent,
  selectVenue,
  selectGenre,
  selectEventImages,
  selectVenueImages,
  selectGenreImages,
  selectAttractImages,
  selectOtherImages
};
